import { Permission, SecurityScope } from '../../../auth/auth.model';
import { AuthService } from '../../../auth/auth.service';
import { epicDependencies } from '../../../store';
import { MainConfig } from '../../core';
import { AllowedActions } from '../model/allowed-actions.model';

export function determineAllowedActions(config: MainConfig): AllowedActions {
    const service = epicDependencies.injector.get<AuthService>(AuthService); // TODO FIXME revise

    const canCreate = service.user.hasPermission(
        Permission.NAV_SUBMIT_EVALUATION,
        SecurityScope.NAV,
    );
    const canSearch = service.user.hasPermission(
        Permission.NAV_VIEW_EVALUATIONS,
        SecurityScope.NAV,
    );
    const editPublish = service.user.hasPermission(
        Permission.EVALUATION_EDIT_PUBLISHED,
        SecurityScope.EVALUATIONS,
    );

    const hasForMyTeamContainer =
        (config?.forMyTeam?.excludeContainerRoleIds?.length > 0 &&
            config?.forMyTeam?.excludeContainerRoleIds?.every(
                (e) => e !== service.user.roleId,
            )) ||
        (config?.forMyTeam?.includeContainerRoleIds?.length > 0 &&
            config?.forMyTeam?.includeContainerRoleIds?.every(
                (e) => e === service.user.roleId,
            ));

    const hasForMyTeamTeamAndSubordinateButton =
        (config?.forMyTeam?.excludeTeamAndSubordinateRoleIds?.length > 0 &&
            config?.forMyTeam?.excludeTeamAndSubordinateRoleIds?.every(
                (e) => e !== service.user.roleId,
            )) ||
        (config?.forMyTeam?.includeTeamAndSubordinateRoleIds?.length > 0 &&
            config?.forMyTeam?.includeTeamAndSubordinateRoleIds?.every(
                (e) => e === service.user.roleId,
            ));

    return {
        create: canCreate,
        search: canSearch,
        editDraft: true, // TODO revise
        editPublish,
        hasForMyTeamContainer,
        hasForMyTeamTeamAndSubordinateButton,
    };
}
